//Javascript for the WECAN Employer Area Signup functionality
app.SavedVacancies = (
    function () {
        var vacancy = {
            Init: function () {
                app.SavedVacancies.AssignFunctionality();
                $(document).on('component-bind-view-mode-complete', function () { app.SavedVacancies.AssignFunctionality() });
            },
            AssignFunctionality: function () {
                $('[data-role="applicant-save-vacancy"]').on('click', function () {
                    //have the icon determine the state
                    var icon = $(this).find('i');
                    var shouldSave = false;
                    if ($(icon).hasClass('fa-star-o')) {
                        //clicked with empty star means we need to save it!
                        shouldSave = true;
                    }
                    //udpate database
                    $.post($(this).data('url'), { id: $(this).data('vacancy-id'), save: shouldSave })
                        .done(function () {
                            //update the ui
                            if ($(icon).hasClass('fa-star')) {
                                //clicked with a filled in star means we need to unsave it!
                                $(icon).removeClass('fa-star');
                                $(icon).addClass('fa-star-o');
                            }
                            else {
                                //clicked with empty star means we need to save it!
                                shouldSave = true;
                                $(icon).addClass('fa-star');
                                $(icon).removeClass('fa-star-o');
                            }
                            //notify user
                            toastr.success("Vacancy saved successfully.");
                        })
                        .fail(function () { toastr.error("Vacancy did not save correctly. Please try again."); });
                });
            }
        };

        return vacancy;
    }()
);